import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { addToCart, removeFromCart } from '../actions/cartActions'
import { Col, ListGroup, Row, Image, FormControl, Card, Button } from 'react-bootstrap'
import Message from '../components/Message'
import { BASE_URL, FRONT_URL } from '../constants/urlConstants'

function CartScreen() {
  const { id } = useParams()
  const productId = id
  const history = useNavigate()
  const location = useLocation()
  const qty = location.search ? Number(location.search.split("=")[1]) : 1
  const dispatch = useDispatch()

  const cart = useSelector(state => state.cart)
  const { cartItems } = cart


  useEffect(() => {
    if (productId) {
      dispatch(addToCart(productId, qty))
    }
  }, [dispatch, productId, qty]
  )

  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id))
  }
  const checkoutHandler = () => {
    // history('/shipping')
  }

  return (
    <Row>
      <Col md={8}>
        <h1>سبد خرید</h1>
        {cartItems.length === 0 ? (
          <Message variant={'info'} text={'cart is empty!'} />
        ) : (
          <ListGroup variant='flush'>
            {cartItems.map(item => (
              <ListGroup.Item key={item.product}>
                <Row>
                  <Col md={2} sm={12}>
                    <Image src={`${BASE_URL}/${item.image}`} alt={item.name} fluid rounded />
                  </Col>
                  <Col md={3} sm={12}>

                    <Link to={`${FRONT_URL}/product/${item.product}`}>{item.name}</Link>
                  </Col>
                  <Col md={2} sm={12}>
                    {item.price} ریال
                  </Col>
                  <Col md={2} sm={12}>
                    <FormControl as="select" value={item.qty}
                      onChange={(e) => dispatch(addToCart(item.product, Number(e.target.value)))}>
                      {
                        [...Array(item.countInStock).keys()].map((x) => (
                          <option key={x + 1} value={x + 1}>
                            {x + 1}
                          </option>
                        ))
                      }

                    </FormControl>
                  </Col>
                  <Col md={1}>
                    <Button type='button' variant='light' onClick={() => removeFromCartHandler(item.product)}>
                      <i className='fas fa-trash'></i>
                    </Button>

                  </Col>
                </Row>
              </ListGroup.Item>
            ))}


          </ListGroup>

        )}

      </Col>
      <Col md={4}>
        <Card>
          <ListGroup>
            <ListGroup.Item>
              <h2>مجموع ({cartItems.reduce(
                (acc, item) => acc + item.qty, 0
              )}) مورد </h2>
              مجموع ({cartItems.reduce(
                (acc, item) => acc + (item.price * item.qty), 0
              )})ریال
            </ListGroup.Item>
            <ListGroup.Item>
              <Button type='button' className='btn-block' disabled={cartItems.length === 0} onClick={checkoutHandler}>
                پرداخت
              </Button>
            </ListGroup.Item>
          </ListGroup>
        </Card>
      </Col>
    </Row>
  )
}

export default CartScreen
